export const defaultPromoData = {
  title: 'signIn:sidebar.title',
  titleColor: 'FFFFFF',
  description: 'signIn:sidebar.message',
  descriptionColor: 'FFFFFF',
  backgroundColor: '3E6A85',
};
